goog.module('yext.storm.logflownav');
goog.module.declareLegacyNamespace();

/**
 * @param {!HTMLElement} el
 */
function clearVarious(el) {
  var $el = $(el);
  if ($el.hasClass('various')) {
    $el.removeClass('various').addClass('notvarious').val('');
  }
}

/**
 * @param {!HTMLElement} formEl
 */
function enableNextInLogFlow(formEl) {
  $('.log-next').removeClass('btn-disabled');
  $('.task-incomplete-bubble').fadeOut(); // hide the "complete this task" bubble
  $(formEl).trigger('log.formChanged'); // temp solution to another problem that will be solved by moving this out of location edit as in above todo
}

/**
 * Disable the next button
 */
function disableNextInLogFlow() {
  $('.log-next').addClass('btn-disabled');
}

exports = {
  clearVarious,
  enableNextInLogFlow,
  disableNextInLogFlow,
};
